module.exports = __webpack_public_path__ + "static/media/ipk2021_love.6cc526cc.jpeg";